import {webClient} from "../../config/axios";
import {handleError} from "../handleRequestError";

export const compareAmbientNoiseRequest = (body,callback) => {
    webClient.post('compare/noise-data', body, {
        headers: {
            "Content-Type": "application/json"
        },
        timeout: 0
    })
        .then(response => {
            callback(response.data, false);
        })
        .catch(err => {
            handleError(err, callback);
        })
};